import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from '@/common/components/Alert/Alert';
import { useEmployeeDetails } from '@/common/contexts/user/UserDetailsContext';
import { AnalyticsService } from '@/common/integrations/analytics/analytics.service';
import { useGetFeatures } from '@/common/integrations/menhir/employee/features/features.hooks';
import { useGetPockets } from '@/common/integrations/menhir/employee/pockets/pockets.hooks';
import {
  getAlertOffboardingMealBalanceDismissed,
  setAlertOffboardingMealBalanceDismissed,
} from '@/common/integrations/storage/storage.service';
import { formatDate, isTodayAfter, parseDate } from '@/common/utils/date';
import { useBenefits } from '@/web/hooks/useBenefits';
import { addMonths } from 'date-fns';

export const AlertOffboardingMeal = () => {
  const [hideAlert, setHideAlert] = useState(true);
  const { t } = useTranslation();
  const { employee } = useEmployeeDetails();
  const {
    features: { FF_CARD },
  } = useGetFeatures();
  const { mealProducts } = useBenefits();
  const { mealPocket } = useGetPockets();

  const handleCloseOffboadingMealAlert = async () => {
    AnalyticsService.trackCustomEvent(
      'offboarding_alert_employee_meal_balance_dismissed'
    );
    await setAlertOffboardingMealBalanceDismissed(true);
    setHideAlert(true);
  };

  useEffect(() => {
    async function checkAlertOffboardingMealBalanceDismissed() {
      const dismissed = await getAlertOffboardingMealBalanceDismissed();
      setHideAlert(dismissed);
    }
    checkAlertOffboardingMealBalanceDismissed();
  }, []);

  const shouldShowAlert = !(
    !mealPocket ||
    !FF_CARD ||
    !mealProducts?.length ||
    hideAlert ||
    employee.invitation !== 'left' ||
    !employee.leavingAt ||
    !isTodayAfter(employee.leavingAt)
  );

  useEffect(() => {
    if (shouldShowAlert) {
      AnalyticsService.trackCustomEvent(
        'offboarding_alert_employee_meal_balance_displayed'
      );
    }
  }, [shouldShowAlert]);

  if (!shouldShowAlert) {
    return null;
  }

  const leavingDate = parseDate(employee?.leavingAt);
  const lastDateToSpend = addMonths(leavingDate, 6);

  return (
    <Alert onClose={handleCloseOffboadingMealAlert}>
      {t('dashboard.alert.offboarding.meal_balance', {
        date: formatDate(lastDateToSpend),
      })}
    </Alert>
  );
};
